import React from 'react';

import type { RegionNumbering } from '../../../generated/generatedOpenAPI';
import type { SequenceData } from '../../types';
import { SequenceWithRegions } from '../common';

interface ChainSequenceCellProps {
  sequence: SequenceData;
  chainKey: 'heavy' | 'light';
  showFWR: boolean;
  highlightedRegions: string[];
  searchQuery: string;
  showLiabilities: boolean;
  showShms: boolean;
  onRegionClick: (region: string | null) => void;
  regionNumbers?: RegionNumbering[];
}

/**
 * Renders a heavy or light chain sequence using the SequenceWithRegions component.
 * Returns null if the requested chain is absent on this sequence.
 */
export function ChainSequenceCell({
  sequence,
  chainKey,
  showFWR,
  highlightedRegions,
  searchQuery,
  showLiabilities,
  showShms,
  onRegionClick,
  regionNumbers,
}: ChainSequenceCellProps) {
  const chain = chainKey === 'heavy' ? sequence.heavyChain : sequence.lightChain;
  if (!chain) {
    return null;
  }
  return (
    <SequenceWithRegions
      sequence={sequence}
      showFWR={showFWR}
      highlightedRegions={highlightedRegions}
      onRegionClick={onRegionClick}
      searchQuery={searchQuery}
      chainKey={chainKey}
      showLiabilities={showLiabilities}
      showShms={showShms}
      regionNumbers={regionNumbers}
    />
  );
}
